"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotepadIcon;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotepadIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement("path", { d: "M15 3C15.5128 3 15.9355 3.38604 15.9933 3.88338L16 3.999L17 4C18.1046 4 19 4.89543 19 6V18C19 19.1046 18.1046 20 17 20H7C5.89543 20 5 19.1046 5 18V6C5 4.89543 5.89543 4 7 4L8 3.999L8.00673 3.88338C8.06449 3.38604 8.48716 3 9 3C9.51284 3 9.93551 3.38604 9.99327 3.88338L10 3.999H11L11.0067 3.88338C11.0645 3.38604 11.4872 3 12 3C12.5128 3 12.9355 3.38604 12.9933 3.88338L13 3.999H14L14.0067 3.88338C14.0645 3.38604 14.4872 3 15 3ZM15 15H9L8.88338 15.0067C8.38604 15.0645 8 15.4872 8 16C8 16.5523 8.44772 17 9 17H15L15.1166 16.9933C15.614 16.9355 16 16.5128 16 16C16 15.4477 15.5523 15 15 15ZM15 11H9L8.88338 11.0067C8.38604 11.0645 8 11.4872 8 12C8 12.5523 8.44772 13 9 13H15L15.1166 12.9933C15.614 12.9355 16 12.5128 16 12C16 11.4477 15.5523 11 15 11ZM15 7H9L8.88338 7.00673C8.38604 7.06449 8 7.48716 8 8C8 8.55228 8.44772 9 9 9H15L15.1166 8.99327C15.614 8.93551 16 8.51284 16 8C16 7.44772 15.5523 7 15 7Z" })
  );
}